<template>
  <div :class="[isContainerClass == true ? 'user-list' : '']">
    <v-card
      v-for="(name, index) in moduleNames"
      :key="name"
      flat
      class="mx-auto my-3"
    >
      <div v-if="!(name === 'admin.communications')" :class="isChildModule(name) ? 'pl-8' : ''">
        <div v-if="name === 'admin.taskmanagement' && !disabled">
          <v-tooltip bottom :disabled="disabled">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-checkbox
                  v-bind="attrs"
                  v-on="on"
                  class="module-name"
                  v-model="selectedModules"
                  multiple
                  :value="name"
                  :label="getModulesName(name)"
                  hide-details
                  @change="onModuleClick(name)"
                  :disabled="disabled"
                  :ref="`${name}`"
                  :id="`${name}`"
                  :indeterminate="isAnySelected(name)"
                ></v-checkbox>
              </div>
            </template>
            <span v-html="$t('permission.tipTaskManagement')"></span>
          </v-tooltip>
        </div>
        <div v-else>
          <v-checkbox
            v-if="!disabled"
            class="module-name"
            v-model="selectedModules"
            multiple
            :value="name"
            :label="getModulesName(name)"
            hide-details
            @change="onModuleClick(name)"
            :disabled="disabled || (name === 'default.permissions')"
            :ref="`${name}`"
            :id="`${name}`"
            :indeterminate="isAnySelected(name)"
          ></v-checkbox>
          <h4 v-else><v-icon x-small class="mr-2 mb-1">mdi-square</v-icon>{{ getModulesName(name) }}</h4>
        </div>
      </div>
      <v-card-text
        v-if="!(name === 'admin.communications')"
        :style="isChildModule(name) ? 'padding: 16px 0 16px 64px !important' : 'padding: 16px 0px  16px 32px !important'"
      >
        <v-row align="center" class="mx-0">
          <div v-for="item in getPermissionsFilterList(name)" :key="item.id">
            <div v-if="name === 'admin.taskmanagement' || name === 'MeetingDocument'">
              <v-tooltip bottom :disabled="disabled">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-bind="attrs"
                      v-on="on"
                      multiple
                      class="mr-10"
                      dense
                      v-model="selectedPermission"
                      hide-details
                      :value="item.id"
                      :label="getModulesName(item.id)"
                      :disabled="disabled || Boolean(item.isDefault)"
                      @change="onPermissionClick(name, item)"
                      :ref="`${item.id}`"
                      :id="`${item.id}`"
                    ></v-checkbox>
                  </div>
                </template>
                <span v-html="$t(`permission.${item.id}`)"></span>
              </v-tooltip>
            </div>
            <div v-else-if="name === 'menu.admin'">
              <v-tooltip bottom :disabled="disabled">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-bind="attrs"
                      v-on="on"
                      multiple
                      class="mr-10"
                      dense
                      v-model="selectedPermission"
                      hide-details
                      :value="item.id"
                      :label="getModulesName(item.id)"
                      :disabled="disabled || Boolean(item.isDefault)"
                      @change="onPermissionClick(name, item)"
                      :ref="`${item.id}`"
                      :id="`${item.id}`"
                    ></v-checkbox>
                  </div>
                </template>
                <span v-html="$t('ViewAdminTip')"></span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-checkbox
                multiple
                class="mr-10"
                dense
                v-model="selectedPermission"
                hide-details
                :value="item.id"
                :label="getModulesName(item.id)"
                :disabled="disabled || Boolean(item.isDefault)"
                @change="onPermissionClick(name, item)"
                :ref="`${item.id}`"
                :id="`${item.id}`"
              ></v-checkbox>
            </div>
          </div>
        </v-row>
      </v-card-text>
      <v-divider
        v-if="
        index < moduleNames.length - 1 && !(name === 'admin.communications')
        "
        :key="index"
        class="ml-1 mr-4 mt-2"
        :class="isParentModule(name) ? 'ml-9' : ''"
      ></v-divider>
    </v-card>
    <a-dialog v-model="antiLockBox" max-width="800px" persistent scrollable>
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span> {{ $t('permission.hConfirmDeletionPer') }} </span>
            <v-spacer></v-spacer>
            <CloseIcon @click="onClose" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="padding: 10px 20px 20px 20px">
          <v-list three-line>
            <v-list-item >
              <v-list-item-avatar style="height: 130px; width: 130px;">
                <!-- <v-img src="https://cdn.vuetifyjs.com/images/lists/1.jpg"></v-img> -->
                <v-icon
                  class="yellow"
                  dark
                  size="100px"
                >
                  mdi-alert
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="text-subtitle-1 font-weight-medium">
                <span v-html="$t('permission.msgConfirmDeletePermission')"></span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mr-2"
                color="primaryDark"
                small
                v-bind="attrs"
                v-on="on"
                @click="confirmAntiLock"
                ><span>{{ $t("btnOk") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnOk") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                color="secondary"
                small
                @click="onClose"
                v-bind="attrs"
                v-on="on"
                ><span>{{ $t("btnClose") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnClose") }} </span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </a-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { permissions, permissionModuleList } from "../../utils/constant";
import { cloneDeep } from "lodash";

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    permissionsList: {
      type: Array,
      default: () => [],
    },
    isContainerClass: {
      type: Boolean,
      default: true,
    },
  },
  
  data() {
    return {
      selectedItem: null,
      selectedModules: [],
      basicPermissionsData: [],
      childPermissionsData: [],
      antiLockBox: false,
      antiLockAdminData: null
    };
  },
  computed: {
    ...mapState({
      //   permissionsList: (state) => state.admin.permissionsList,
    }),
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    selectedPermission: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
    permissionsListData() {
      return this.masterSettingTypes("permissions");
    },
    filteredPermissionsList() {
      if (this.permissionsList.length) {
        let list = this.permissionsList;
        let result = list.reduce(function (r, a) {
          r[a.screenName] = r[a.screenName] || [];
          r[a.screenName].push(a);
          return r;
        }, Object.create(null));
        result = { ...result };
        return result;
      } else {
        return {};
      }
    },
    filterRelativePermissions() {
      if (this.permissionsList.length) {
        let list = this.permissionsList;
        let result = list.reduce(function (accumulator, current) {
          if (current.parentScreenName) {
            accumulator[current.parentScreenName] = accumulator[current.parentScreenName] || [];
            accumulator[current.parentScreenName].push(current);
          }
          return accumulator;
        }, Object.create(null));
        result = { ...result };
        return result;
      } else {
        return {};
      }
    },
    moduleNames() {
      return Object.keys(this.filteredPermissionsList);
    },
  },
  mounted() {
    if (Object.keys(this.filteredPermissionsList).length > 0) {
      for (const obj in this.filteredPermissionsList) {
        let isAllSelected = this.filteredPermissionsList[obj]?.every((p) =>
          this.selectedPermission.includes(p.id)
        );
        if (isAllSelected) {
          if (!this.selectedModules.includes(obj)) {
            this.selectedModules.push(obj);
          }
        }
        if (this.permissionsList && this.permissionsList.length > 0) {
          // Get the basic permissions for all the modules
          this.basicPermissionsData = this.permissionsList.filter(
            (permissionObj) => Boolean(permissionObj.isBasic)
          );
        }
      }
    }
  },
  methods: {
    isChildModule(name) {
      return this.getCurrentModuleData(name).every(p => p?.parentScreenName)
    },
    isParentModule(name) {
      return this.getCurrentModuleData(name).some(p =>
        Object.keys(this.filterRelativePermissions).includes(p.id));
    },
    isAnySelected(name) {
      const currentModuleArr = this.getCurrentModuleData(name);
      let isAllSelected = currentModuleArr.every((obj) =>
        this.selectedPermission.includes(obj.id)
      );
      if (isAllSelected) {
        return false;
      } else {
        return currentModuleArr.some(
          (obj) =>
            this.selectedPermission.includes(obj.id) &&
            obj.screenName === name &&
            currentModuleArr.length > 1
        );
      }
    },
    getCurrentModuleData(name) {
      return this.getPermissionsFilterList(name);
    },
    getChildPermission(item) {
      if (Object.keys(this.filterRelativePermissions).length > 0) {
        for (const obj in this.filterRelativePermissions) {
          if (item?.parentScreenName == obj || item.screenName == obj) {
            return this.filterRelativePermissions[obj];
          }
        }
      }
    },
    onPermissionClick(name, item) {
      const currentModuleArr = this.getCurrentModuleData(name); // Get the data of current module
      let modulePermissions = currentModuleArr.map((p) => p.id); // Get all permission of current module.

      // Get the data of child permissions
      let allChildData = this.getChildPermission(item) || [];

      if (!this.selectedPermission.includes(item.id)) {
        // Check if current permission is not selected
        this.selectedPermission.push(item.id);
        let parentPermission = this.basicPermissionsData.filter(i => i.screenName === item.parentScreenName && i.isBasic)
        // Check if current permission is from child permission
        if (item.parentScreenName && !this.selectedPermission.includes(parentPermission[0]?.id)) {
          let arr = this.selectedPermission;
          arr.push(parentPermission[0]?.id); // Select child permission
          this.selectedPermission = arr;
        }

        let newArr = this.selectedPermission; // To select relative permissions
        this.basicPermissionsData.forEach((obj) => {
          if (
            item.screenName === obj.screenName &&
            !this.selectedPermission.includes(obj.id)
          ) {
            newArr.push(obj.id);
            this.selectedPermission = newArr;
          }
        });
        let isAllSelected = modulePermissions.every((p) =>
          this.selectedPermission.includes(p)
        );
        this.moduleSelection(isAllSelected, name);
      } else {
        
        // Check if current permission is selected
        const index = this.selectedPermission.indexOf(item.id);

        if (index >= 0) {
          if(item.id === "ViewAdmin" && this.antiLockAdminData === null){
            this.antiLockBox = true;
            this.antiLockAdminData = {...item, ...{type: 'permission'}};
            return;
          }

          this.selectedPermission.splice(index, 1);

          let newArr = this.selectedPermission; // To unselect relative permissions
          this.basicPermissionsData.forEach((obj) => {
            if (item.screenName === obj.screenName && item.id === obj.id) {
              let currModuleData = this.getCurrentModuleData(item.screenName);
              currModuleData.map((p) => {
                if (newArr.includes(p.id) && !newArr.includes(item.id)) {
                  const index = newArr.indexOf(p.id);
                  if (index >= 0) {
                    newArr.splice(index, 1);
                    this.selectedPermission = newArr;
                  }
                }
              });
            }
          });
          
          // Check if current permission is Parent permission and it is not selected
          if (
            this.filterRelativePermissions.hasOwnProperty(item.screenName) && item.isBasic &&
            !this.selectedPermission.includes(item.id) &&
            allChildData.length
          ) {
            allChildData.forEach((per) => {
              let isAvailable = this.selectedPermission.includes(per.id);
              const index = this.selectedPermission.indexOf(per.id);
              if (isAvailable && index >= 0) {
                let arr = this.selectedPermission;
                arr.splice(index, 1); // Unselect all the child permissions
                this.selectedPermission = arr;
              }
            });
            // Check if all child permissions are selected or not
            let isAllUnSelected = allChildData.every(
              (per) => !this.selectedPermission.includes(per.id)
            );
            if (
              isAllUnSelected &&
              this.selectedModules.includes(allChildData[0].screenName)
            ) {
              // Unselect child module if all the permissions are unselected
              const index = this.selectedModules.indexOf(
                allChildData[0].screenName
              );
              if (index >= 0) {
                this.selectedModules.splice(index, 1);
              }
            }
          }
        }
        let isAllSelected = modulePermissions.every((p) =>
          this.selectedPermission.includes(p)
        );
        this.moduleSelection(isAllSelected, name);
      }
    },
    moduleSelection(isAllSelected, name) {
      if (isAllSelected) {
        // Select module checkbox if all permissions are selected.
        if (!this.selectedModules.includes(name)) {
          this.selectedModules.push(name);
        }
      } else {
        // Unselect module checkbox if one of the permission is unselected.
        const index = this.selectedModules.indexOf(name);
        if (index >= 0) {
          this.selectedModules.splice(index, 1);
        }
      }
    },
    onModuleClick(name) {
      let currentModuleArr = this.getCurrentModuleData(name); // Get the data of current module

      let arr = this.permissionsList.filter(
        (p) => p.screenName === name && p.isBasic || p.parentScreenName === name
      );

      
      let allChildData = [];
      if (arr.length) {
        // Get the data of child module
        allChildData = this.getChildPermission(arr[0]) || [];
      }

      if (this.$refs[name][0].id === name && this.$refs[name][0].isActive) {
        // Condition for current module is selected
        if (currentModuleArr && currentModuleArr.length > 0) {
          currentModuleArr.forEach((obj) => {
            if (
              !this.selectedPermission.includes(obj.id) &&
              this.$refs[obj.id][0].id === obj.id &&
              !this.$refs[obj.id][0].isActive
            ) {
              this.selectedPermission.push(obj.id);
            }
          });
        }
        // Select child module & permissions
        if (allChildData.length) {
          allChildData.map((per) => {
            if (!this.selectedPermission.includes(per.id)) {
              this.selectedPermission.push(per.id);
            }
          })
          let isAllSelected = allChildData.every((p) =>
            this.selectedPermission.includes(p.id)
          );
          if (isAllSelected && !this.selectedModules.includes(allChildData[0].screenName)) {
            this.selectedModules.push(allChildData[0].screenName);
          }
        }

        // Select parent permission if It's not selected
        let parentPermission = this.basicPermissionsData.filter(i => i.screenName === allChildData[0]?.parentScreenName && i.isBasic)
        if (
          allChildData.length &&
          this.$refs[name][0].id === name &&
          this.$refs[name][0].isActive &&
          !this.selectedPermission.includes(parentPermission[0]?.id)
        ) {
          this.selectedPermission.push(parentPermission[0]?.id);
        }
      } else if (
        this.$refs[name][0].id === name &&
        !this.$refs[name][0].isActive
      ) {
        if(name === "menu.admin" && !this.antiLockAdminData){
          this.antiLockBox = true;
          this.antiLockAdminData = {screenName: name, name: name, type: 'module'};
          return
        }

        // Condition for current module is not selected
        if (currentModuleArr && currentModuleArr.length > 0) {
          currentModuleArr.forEach((obj) => {
            const index = this.selectedPermission.indexOf(obj.id);
            if (
              this.selectedPermission.includes(obj.id) &&
              index >= 0 &&
              this.$refs[obj.id][0].id === obj.id &&
              this.$refs[obj.id][0].isActive
            ) {
              this.selectedPermission.splice(index, 1);
            }
          });
        }

        if (
          allChildData.length &&
          !this.$refs[allChildData[0]?.parentScreenName].isActive
        ) {
          // if parent permission is unselected

          allChildData.forEach((per) => {
            let isAvailable = this.selectedPermission.includes(per.id);
            const index = this.selectedPermission.indexOf(per.id);
            if (isAvailable && index >= 0) {
              this.selectedPermission.splice(index, 1); // Unselect all child permissions
            }
          });
          let isAllUnSelected = allChildData.every(
            (per) => !this.selectedPermission.includes(per.id)
          );
          // Check if all the child permissions are selected or not
          if (
            isAllUnSelected &&
            this.selectedModules.includes(allChildData[0].screenName)
          ) {
            const index = this.selectedModules.indexOf(
              allChildData[0].screenName
            );
            if (index >= 0) {
              this.selectedModules.splice(index, 1); // Unselect child module
            }
          }
        }
        
      }
    },
    getPermissionsFilterList(name) {
      return this.permissionsList.filter((p) => p.screenName === name);
    },
    getModulesName(name) {
      return this.$t(name);
    },
    onClose() {
      const selectedData = cloneDeep(this.antiLockAdminData);
      this.antiLockAdminData = null
      if(selectedData.type === "permission"){
        this.onPermissionClick(selectedData.screenName, selectedData);
      }else{
        this.moduleSelection(true, selectedData.screenName);
      }
      this.antiLockBox = false;
    },
    confirmAntiLock(){
      const selectedData = cloneDeep(this.antiLockAdminData);
      if(selectedData.type === "permission"){
        this.moduleSelection(false, selectedData.screenName);
      }else{
        this.unSelectModulePermissions(selectedData)
      }
      this.antiLockAdminData = null
      this.antiLockBox = false;
    },
    unSelectModulePermissions(selectedData){
      let currentModuleArr = this.getCurrentModuleData(selectedData.screenName); // Get the data of current module
            let arr = this.permissionsList.filter(
            (p) => p.screenName == selectedData.screenName && p.isBasic || p.parentScreenName === selectedData.screenName
          );
          let allChildData = [];
          if (arr.length) {
            // Get the data of child module
            allChildData = this.getChildPermission(arr[0]) || [];
          }
        if (currentModuleArr && currentModuleArr.length > 0) {
          currentModuleArr.forEach((obj) => {
            const index = this.selectedPermission.indexOf(obj.id);
            if (
              this.selectedPermission.includes(obj.id) &&
              index >= 0 &&
              this.$refs[obj.id][0].id === obj.id &&
              this.$refs[obj.id][0].isActive
            ) {
              this.selectedPermission.splice(index, 1);
            }
          });
        }
        if (
          allChildData.length &&
          !this.$refs[allChildData[0]?.parentScreenName].isActive
        ) {
            // if parent permission is unselected

            allChildData.forEach((per) => {
              let isAvailable = this.selectedPermission.includes(per.id);
              const index = this.selectedPermission.indexOf(per.id);
              if (isAvailable && index >= 0) {
                this.selectedPermission.splice(index, 1); // Unselect all child permissions
              }
            });
            let isAllUnSelected = allChildData.every(
              (per) => !this.selectedPermission.includes(per.id)
            );
            // Check if all the child permissions are selected or not
            if (
              isAllUnSelected &&
              this.selectedModules.includes(allChildData[0].screenName)
            ) {
              const index = this.selectedModules.indexOf(
                allChildData[0].screenName
              );
              if (index >= 0) {
                this.selectedModules.splice(index, 1); // Unselect child module
              }
            }
          }
    }
  },
};
</script>
<style scoped>
.module-name /deep/ .v-input__control .v-label {
  color: var(--v-darkCharcoal-base);
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}
</style>